import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Badge, List, Typography } from 'antd';

import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function ProductApproved() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);

  const products = (notifications || []).find(n => n.type === ENotificationType.APPROVED_PRODUCT);
  if (!products?.quantity) return null;

  return (
    <Link to={`/producer/notifications/${ENotificationType.APPROVED_PRODUCT}`}>
      <List.Item extra={<Badge count={products?.quantity || 0} color='blue' showZero />}>
        <Typography.Text strong>Produtos Aprovados</Typography.Text>
      </List.Item>
    </Link>
  );
}
